module.exports = __webpack_public_path__ + "img/page47.6d322c11.gif";